import {
  common
} from "../common/lang/zh"

export function changeTime(time) {
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return window.vm.$i18n.t('common.momentAgo')
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + window.vm.$i18n.t('common.minutesAgo')
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + window.vm.$i18n.t('common.hourAgo')
  } else if (diff < 3600 * 24 * 2) {
    return 1 + window.vm.$i18n.t('common.daysAgo')
  } else if (diff < 3600 * 24 * 3) {
    return 2 + window.vm.$i18n.t('common.daysAgo')
  } else if (diff < 3600 * 24 * 4) {
    return 3 + window.vm.$i18n.t('common.daysAgo')
  } else if (diff < 3600 * 24 * 5) {
    return 4 + window.vm.$i18n.t('common.daysAgo')
  } else if (diff < 3600 * 24 * 6) {
    return 5 + window.vm.$i18n.t('common.daysAgo')
  } else if (diff < 3600 * 24 * 7) {
    return 6 + window.vm.$i18n.t('common.daysAgo')
  }else if (diff > 3600 * 24 * 7) {

   let arr= time.split(' ')

     return arr[0]
  }



  return time
}



// WEBPACK FOOTER //
// ./src/utils/msgTime.js